import { FC } from 'react';
import {
  createBemBlockBuilder,
  IndeterminateSpinner,
} from '@ebsco-ui/ebsco-ui';

import './ComponentSpinner.scss';

interface ComponentSpinnerProps {
  id?: string;
}

const cnBem = createBemBlockBuilder(['componentSpinner']);

export const ComponentSpinner: FC<ComponentSpinnerProps> = ({ id }) => {
  return (
    <div data-auto="spinner" className={cnBem()} id={id}>
      <IndeterminateSpinner level="component" />
    </div>
  );
};
